import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const Header = () => {
    const navigate=useNavigate()
    const location=window.location.pathname
    const token=useSelector((state)=>state?.auth?.token)

    console.log(token);
    
  return (
    <div className='w-full fixed top-0 z-999' style={{height:"70px",backgroundColor:"white"}}>
     {location==="/"?
      <div className='flex items-center justify-center bg-white p-4 border-black'>
        <p onClick={()=>navigate('/')} style={{fontSize:"26px",fontWeight:"700",cursor:"pointer"}}>Swasthya 
          <span style={{color:"#1d5aff",fontWeight:"800"}}> Khata </span>
          <span style={{fontWeight:"400"}}>(Diagnostics)</span></p>


       

      </div>
     : 
      <div className='flex items-center justify-between bg-white p-4 border-black'>
        <p onClick={()=>navigate('/dashboard')} style={{fontSize:"26px",fontWeight:"700",cursor:"pointer"}}>
          Swasthya<span style={{color:"#1d5aff",fontWeight:"800"}}> Khata </span>
          <span style={{fontWeight:"400"}}>(Diagnostics)</span>
        </p>

           <div className='flex items-center justify-center gap-6'>
                <p onClick={()=>navigate('/find-doctors')}
                    className='cursor-pointer text-gray-500 font-bold'>Find Doctors</p>
                     <p onClick={()=>navigate('/find-hospitals')}
                    className='cursor-pointer text-gray-500 font-bold'>Find Hospitals</p>
                <p onClick={()=>navigate('/request')}
                    className='cursor-pointer text-gray-500 font-bold'>Request</p>
                     <p onClick={()=>navigate('/patients')}
                    className='cursor-pointer text-gray-500 font-bold'>Patients</p>
            </div>

        <p onClick={()=>navigate('/login')}
        style={{padding:"8px",backgroundColor:"#226df8ff",fontSize:"15px",borderRadius:"10px",color:"white",fontWeight:"700",cursor:"pointer"}}>
          Account</p>

      </div>}
    </div>
  )
}

export default Header
